import { Injectable } from "@angular/core";
import { CustomFormControl, CustomFormControlProps, CustomFormGroup } from "@tilby/tilby-ui-lib/components/tilby-magic-form";
import { ItemDefault, ItemFields, ItemsForm } from "src/app/features/items/models/items-form.model";
import { ItemInventoryFormGroups, ItemInventoryValidators } from "./item-inventory.model";
import { Validators } from "@angular/forms";

@Injectable()
export class ItemInventoryFormService {

    itemInventoryForm!: ItemInventoryFormGroups;

    validators: ItemInventoryValidators = {
        skuMaxLength: 64,
        codeMaxLength: 255,
        weightMin: 0,

        // --------
        provMinLength: 0,
        provMaxLength: 255,
        provMaxLengthArray: new Array(10).fill(2)
    };

    createForm(item: ItemFields = new ItemDefault() ,hiddenFields?:Array<keyof ItemFields>) {

        this.itemInventoryForm = new CustomFormGroup<ItemsForm>({
            unit: new CustomFormControl(
                item.unit || null,
                {}, 
                {
                    ...new CustomFormControlProps(),
                    inputType: 'select'
                }
            ),
            sku: new CustomFormControl(
                item.sku || null, 
                { validators: [Validators.maxLength(this.validators.skuMaxLength)] }, 
            ),
            code: new CustomFormControl(
                item.code || null, 
                { validators: [Validators.maxLength(this.validators.codeMaxLength)] }, 
            ),
            weight: new CustomFormControl(
                item.weight || null, 
                { validators: [Validators.min(this.validators.weightMin)] }, 
                {
                    ...new CustomFormControlProps(),
                    inputType: 'number'
                }
            ),
        })

        return this.itemInventoryForm;
    }

    get unit() {
        return this.itemInventoryForm?.controls.unit;
    }

    get sku() {
        return this.itemInventoryForm?.controls.sku;
    }

    get code() {
        return this.itemInventoryForm?.controls.code;
    }

    get weight() {
        return this.itemInventoryForm?.controls.weight;
    }
}